module.exports = __webpack_public_path__ + "static/media/brazilianplayerparrot.262785c0.gif";